import { Card, Col, Divider, Row, Skeleton } from "antd";
import React, { useContext } from "react";
import { ManageBrandContext } from ".";
import { OpenFieldIcon } from "../../../../assets/icons/OpenFieldIcon";
import { CardTitle } from "../../../../styles/StyledComponents";

export const ItemsAssigned = () => {
  const { brand, isLoading } = useContext(ManageBrandContext);
  return (
    <Card
      type="inner"
      title={<CardTitle>Items Assigned</CardTitle>}
      bodyStyle={{ padding: 10, minHeight: 100 }}
    >
      <Skeleton loading={isLoading}>
        {brand?.items?.length ? (
          brand?.items?.map((item, index) => (
            <Row justify="space-between" key={item.id} align="middle">
              <Col>
                <div
                  style={{ fontWeight: 600, fontSize: 14, lineHeight: "17px", color: "#64748B" }}
                >
                  {item.inventoryNumber}
                </div>
              </Col>
              <Col>
                <OpenFieldIcon style={{ cursor: "pointer" }} />
              </Col>
              {brand.items ? !!brand?.items[index + 1] : false && <Divider style={{ margin: 0 }} />}
            </Row>
          ))
        ) : (
          <div
            style={{
              fontWeight: 600,
              fontSize: 14,
              lineHeight: "17px",
              height: "100%",
              color: "#64748B",
            }}
          >
            No items assigned
          </div>
        )}
      </Skeleton>
    </Card>
  );
};
